// @import dependencies
import React, {Component} from 'react'
import { connect } from 'react-redux'
import { CombinedReducers as IState } from 'app_events/index'
// @end

// @import components
import {NewsCardCommonLayout} from 'app_components/commons/newsCard'
// @end

// @import events
// @end

// @import utils
// @end

// @import services
// @end

// @import types
// @end

// @ADD Component types
interface INewsCardCommonProps {
  cover: string,
  postDate: string,
  title: string
  subtitle: string
  version?: 'simple' | 'large'
  list?: boolean
  live?: boolean
  onClick?: () => void
}
interface INewsCardCommonState {
  versioning: 'simple' | 'large'
}

// @INFO: Connect react storage state
const mapStatesToProps = (state: IState) => {return state}

class NewsCardCommon extends Component<INewsCardCommonProps, INewsCardCommonState> {

  /*===============================================
  =            Estructura de un metodo            =
  ================================================
    // La estructura de un metodo debe ser la siguiente:
    methodName = () => {}
  /*======  End of Estructura de un metodo  =====*/

  constructor(props: INewsCardCommonProps) {
    super(props)
    this.state = {
      versioning: 'large'
    }
  }

  /**
   * Evento que se ejecuta cuando el componente es montado
   */
  componentDidMount = async () => {
    if (this.props.version) {
      this.setState({versioning: this.props.version})
    }
  }

  /**
   * Evento que se ejecuta cuando el componente es desmontado
   */
  componentWillUnmount = () => {}

  /**
   * Evento que se ejecuta cuando el componente es actualizado
   */
  componentDidUpdate = () => {}

  // @Add custom methods

  render() {
    return(
      <NewsCardCommonLayout
        {...this.props}
        version={this.state.versioning}
      />
    )
  }
}

export default connect(mapStatesToProps)(NewsCardCommon)
